export { NotFound as default } from '~/components/pages/404/404';
